import { render } from "./stepUpload.vue?vue&type=template&id=2c707ed2&scoped=true"
import script from "./stepUpload.vue?vue&type=script&lang=js"
export * from "./stepUpload.vue?vue&type=script&lang=js"

import "./stepUpload.vue?vue&type=style&index=0&id=2c707ed2&scoped=true&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c707ed2"]])

export default __exports__